import {
  emptyString,
  errorMessages,
  successMessages,
  surveyQuestionsConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { surveyQuestionService } from "../../services";
import {
  withSpinner,
  success,
  failure,
} from "../../../../redux/actions/utilities";

const { UPDATED_SUCCESSFULLY } = successMessages;
const { SEQUENCE_WITH_NO_ELEMENT } = errorMessages;
const { IS_CHANGES, ADD_QUESTION, GET_QUESTIONS, GET_RECIPIENTS, UPDATE_RECIPIENTS } = surveyQuestionsConstants;

//Adding survey
const addQuestion = (body, brandId, additionalQuestions) => {
  let updatedBody = {
    ...body,
    surveyQuestions: [...body.surveyQuestions, ...additionalQuestions],
  };
  return (dispatch) => {
    withSpinner(dispatch, ADD_QUESTION, () =>
      surveyQuestionService
        .addQuestion(updatedBody, brandId)
        .then(
          (_response) => {
            dispatch(setIsAddedSurvey(true));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};
//Getting survey
const getSurveyQuestions = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_QUESTIONS, () =>
      surveyQuestionService
        .getSurveyQuestions(brandId)
        .then(
          (response) => {
            dispatch(success(response, GET_QUESTIONS));
          },
          (error) => {
            dispatch(failure(error, GET_QUESTIONS));
            if (error[0] !== SEQUENCE_WITH_NO_ELEMENT) {
              customToast(error[0], toastTypes.ERROR);
            }
          }
        )
    );
  };
};

//Getting survey recipients
const getSurveyRecipients = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_RECIPIENTS, () =>
      surveyQuestionService
        .getSurveyRecipients(brandId)
        .then(
          (response) => {
            dispatch(success(response, GET_RECIPIENTS));
          },
          (error) => {
            dispatch(failure(error, GET_RECIPIENTS));
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Updating survey recipients
const updateSurveyRecipients = (body, brandId) => {
  return (dispatch) => {
    return withSpinner(dispatch, UPDATE_RECIPIENTS, () =>
      surveyQuestionService
        .updateSurveyRecipients(body, brandId)
        .then(
          (_response) => {
            dispatch(getSurveyRecipients(brandId));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Getting recipients emails against locationId
const setIsChanges = (flag) => {
  return (dispatch) => {
    dispatch(success(flag, IS_CHANGES));
  };
};

//Updating state if we add survey
const setIsAddedSurvey = (flag) => {
  return (dispatch) => {
    dispatch(success(flag, ADD_QUESTION));
  };
};

const emptySurveyQuestionInRedux = () => {
  return (dispatch) => {
    dispatch(failure(emptyString, GET_QUESTIONS));
  };
};

export const surveyQuestionActions = {
  addQuestion,
  setIsChanges,
  setIsAddedSurvey,
  getSurveyQuestions,
  getSurveyRecipients,
  updateSurveyRecipients,
  emptySurveyQuestionInRedux,
};
